
export default function travel( state = { 'OUTPUT' : { 'DATA' : [1] } }, action = {} ){

    switch( action.type ){
        case 'SAVE_TRAVEL':
            return action.travel
        case 'GET_TRAVEL':
            return action.travel
        case 'GET_TRAVEL_BY_ID':
            return action.travel
        case 'DELETE_TRAVEL':
            return action.travel
        case 'UPDATE_TRAVEL':
            return action.travel
        default: return [];
    }

}



// WEBPACK FOOTER //
// ./src/store/reducers/travel/travel.reducer.js